import RouteIcon from '@mui/icons-material/Route';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid2';
import { Box, Button, Divider, Typography } from '@mui/material';
import { ROUTE_TYPES } from '../../../../config/consts/routes';
import RouteHelpAlert from './RouteHelpAlert';

function ActiveStateRoute({ routeType }) {
  const navigate = useNavigate();
  const { t } = useTranslation(['title', 'description']);

  const ACTIVE_ROUTE_BY_ROUTE_TYPE = {
    [ROUTE_TYPES.SAME_DAY || ROUTE_TYPES.EXPRESS_SCHEDULED]: {
      titleKey: 'routes.active',
      messageKey: 'routes.active',
    },
    [ROUTE_TYPES.EXPRESS]: {
      titleKey: 'routes.active',
      messageKey: 'routes.active_express_message',
    },
  };

  const { titleKey, messageKey } =
    ACTIVE_ROUTE_BY_ROUTE_TYPE[routeType] ||
    ACTIVE_ROUTE_BY_ROUTE_TYPE[ROUTE_TYPES.SAME_DAY];

  return (
    <Card sx={{ mb: 2, borderRadius: 2 }}>
      <CardContent>
        <Grid container spacing={2} sx={{ textAlign: 'center' }}>
          <Grid size={12}>
            <RouteIcon
              sx={{ fontSize: 45, color: (theme) => theme.palette.grey[600] }}
            />
          </Grid>
          <Grid size={12}>
            <Typography sx={{ fontWeight: 500, fontSize: 20 }}>
              {t(titleKey, { ns: 'title' })}
            </Typography>
          </Grid>

          <Grid size={12}>
            <Trans
              t={t}
              i18nKey={messageKey}
              ns="description"
              components={[
                <Typography component="strong" sx={{ fontWeight: 600 }} />,
                <Box sx={{ height: 24 }} />,
                <Button
                  onClick={() => navigate('/orders/dashboard')}
                  color="primary"
                  variant="contained"
                  fullWidth
                />,
              ]}
            />
          </Grid>
          <Divider sx={{ my: 1, width: '100%' }} />
          <Grid sx={{ textAlign: 'left', padding: 0 }} size={12}>
            <RouteHelpAlert />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ActiveStateRoute;
